"use strict";

class EBallotionController {

    constructor($rootScope, $scope, $localStorage, $window, $timeout, Fullscreen, SSUserService, SSHttpService, SSUtilService, SSAlertService, SSConfirmationService, SSAppService, SSAwsService, OTPService, SSConfigService, SSStackviewService) {
        const self = this;

        self.$rootScope = $rootScope;
        self.$scope = $scope;
        self.$localStorage = $localStorage;
        self.$timeout = $timeout;
        self.$window = $window;

        self.Fullscreen = Fullscreen;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;
        self.SSUtilService = SSUtilService;
        self.SSHttpService = SSHttpService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSStackviewService = SSStackviewService;

        self.data = SHOWSUITE.data;

        self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
        self.EOI_STATUS_TRANSFERRED = SHOWSUITE.EOI_STATUS_TRANSFERRED;
        self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
        self.EOI_STATUS_VERIFIED = SHOWSUITE.EOI_STATUS_VERIFIED;
        self.EOI_STATUS_WITHDRAWN = SHOWSUITE.EOI_STATUS_WITHDRAWN;
        self.EOI_STATUS_REJECTED = SHOWSUITE.EOI_STATUS_REJECTED;
        self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
        self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
        self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
        self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

        self.PROPERTY_ASSET_TYPE_LOGO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_LOGO_IMAGE;
        self.PROPERTY_ASSET_TYPE_BALLOTING_B1 = SHOWSUITE.PROPERTY_ASSET_TYPE_BALLOTING_B1;
        self.PROPERTY_ASSET_TYPE_BALLOTING_B2 = SHOWSUITE.PROPERTY_ASSET_TYPE_BALLOTING_B2;

        self.EOI_TYPE_SINGLE_PURCHASE = SHOWSUITE.EOI_TYPE_SINGLE_PURCHASE;
        self.EOI_TYPE_MULTIPLE_PURCHASE = SHOWSUITE.EOI_TYPE_MULTIPLE_PURCHASE;

        /** WEB-2843 E-Balloting - Unit Placement Method - START **/
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;

        self.UNIT_STATUSES_DISPLAYNAME_MAP = {};
        self.UNIT_STATUSES_DISPLAYNAME_MAP[self.UNIT_STATUS_LISTED] = "Listed";
        self.UNIT_STATUSES_DISPLAYNAME_MAP[self.UNIT_STATUS_DRAFT] = "Draft";
        self.UNIT_STATUSES_DISPLAYNAME_MAP[self.UNIT_STATUS_RESERVED] = "Reserved";
        self.UNIT_STATUSES_DISPLAYNAME_MAP[self.UNIT_STATUS_BOOKED] = "Booked";
        self.UNIT_STATUSES_DISPLAYNAME_MAP[self.UNIT_STATUS_SOLD] = "Sold";

        self.UNIT_CATEGORIES_MAP = {
            0: {code: 'XX', name: 'Other', className: 'empty'},
            1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
            2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
            3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
            4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
            5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
            6: {code: 'PH', name: 'Penthouse', className: 'ph'},
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: {code: 'DE', name: 'Detached', className: 'detached'},
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };
        /** WEB-2843 E-Balloting - Unit Placement Method - END **/

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }

        self.restrictToFirstChoice = false;
    }

    init() {
        const self = this;

        self.code_length = 8;

        self.eoisStatuses = [
            self.EOI_STATUS_VERIFIED,
            self.EOI_STATUS_REGISTERED
        ];

        self.showBallotingOptionsPage = true;
        self.showOneByOneBallotingPage = false;

        // Balloting order
        // [switch-off] Order - Ascending -- false
        // [switch-on] Order - Descending -- true

        self.balloting_order_descending = true;

        self.data.eois = [];
        self.balloted_eois = [];

        self.offset = 0;
        self.limit = 10;
        self.selectedRows = "" + self.limit;

        self.totalEoisCount = 0;
        self.ballotedEoisCount = 0;
        self.draw_option_value = '1';
        // self.initDrawOptionValues();

        self.show_fireworks = true;
        self.play_animation_sound = true;
        self.show_balloting_info = true;
        self.show_buyer_info = false;
        self.STOP_AUTO_DRAW = false;

        self.is_full_screen = false

        self.animation_speed = 110;
        self.animation_duration = 11;
        self.fireworks_duration = 2500;
        
        self.getAllEois();
        self.initAsciiCodes();
        self.fireworks_sound = self.initSoundEffect("/audio/fireworks.mp3");
        self.mouse_click_sound = self.initSoundEffect("/audio/mouse-click.mp3");
        self.animation_sound = self.initSoundEffect("/audio/slot-machine-spin.wav");

        if(self.data.property_id){
            self.getProperty(self.data.property_id);
        }

        /** WEB-2843 E-Balloting - Unit Placement Method - START **/
        self.property = null;
        self.first = 2; // First choice = 2, All choices = 1
        self.viewType = 1;
        self.propertyIDEBalloting=-1;
        self.eoiDateCheck = false;

        self.unitEoiByPhase = {};

        self.unit_categories = {};
        self.filtered_categories = [];
        self.total_eois_by_phase = 0;

        self.sortBy = null;
        self.sortByHeading = "Sort by...";
        self.selectedStackId = null;

        self.apiOffset = 0;
        self.apiLimit = 100;

        self.initEOisStatuses();
        /** WEB-2843 E-Balloting - Unit Placement Method - END **/

        /** WEB-2860 Stack View: Need to add more details in each cell - START **/
        self.stackviewSettings = { // Init stackview_settings defaults
            show_floor_pan: false
        }
        if( self.SSStackviewService.getStackViewSettings() ){
            self.stackviewSettings = self.SSStackviewService.getStackViewSettings(self.stackviewSettings);
        }
        /** WEB-2860 Stack View: Need to add more details in each cell - END **/
        self.handleKeyShortCuts();
    }

    // API Calls
    //---------------------------------------------

    getProperty(property_id) {
        const self = this;

        if(!property_id){
            return;
        }

        let url = 'sec/developer/properties/' + property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.code_length = 6 + self.property.short_code.length;

            self.filterPropertyAssets();
            self.getPhase();
        });
    }

    sendBallotingEmails(){
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            "Are you sure you want to send balloting emails to all buyers?",
            self.SSConfirmationService.TYPE_YES_NO,
            function (confirmationStatus) {
                self.sendEmails();
            }
        );
    }

    sendEmails(){
        const self = this;

        // Need to update url
        let url = 'sec/eois/bulk-eois-emails';
        let params = {
            balloted_eois: true,
            property_launch_id: self.data.launchId
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            
            self.SSAlertService.success('Success!', 'Balloting emails added to queue successfully.');
        });
    }

    // Assets ----------------------------------------------------------------------------------------------------------
    filterPropertyAssets() {
        const self = this;

        self.assetFiles = {};

        if (self.property.property_assets) {
            _.forEach(self.property.property_assets, function (asset) {
                if (!_.has(self.assetFiles, asset.type))
                    self.assetFiles[asset.type] = [];

                asset.show_file_uri = self.SSUtilService.makeAssetUrl(asset.file_uri);
                self.assetFiles[asset.type].push(asset);
            });
        }
    }

    // Assets
    uploadPropertyFiles(files, type) {
        const self = this;

        if (!files || !type)
            return;

        let policyUrl = 'sec/developer/properties/' + self.property.id + '/assets/s3-policy-document';

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policyObj) {
            loading(false);

            if (policyObj instanceof Error) {
                self.SSAlertService.error("Unable to upload file. Please contact support.");
                return;
            }

            jQuery.each(files, function (i, file) {

                loading(true);
                self.SSAwsService.upload(file, policyObj, function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.addAsset(type, response.config.data.file.name, response.config.data.key);
                });
            });
        });
    }

    addAsset(type, name, fileUri) {
        const self = this;

        if (!(type && name && fileUri))
            return;

        let url = 'sec/developer/properties/' + self.property.id + '/assets/add-asset';
        let params = {
            "type": type,
            "name": name,
            "file_uri": fileUri
        };

        let handleResponse = function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSUtilService.logError("Error in uploading Asset with path " + fileUri);
                return;
            }

            $('#updateSettingsModal').modal('hide');
            
            response.data.show_file_uri = self.SSUtilService.makeAssetUrl(response.data.file_uri);
            
            if(type == self.PROPERTY_ASSET_TYPE_BALLOTING_B1){
                if (!_.has(self.assetFiles, self.PROPERTY_ASSET_TYPE_BALLOTING_B1)){
                    self.assetFiles[self.PROPERTY_ASSET_TYPE_BALLOTING_B1] = [];
                }
                self.assetFiles[self.PROPERTY_ASSET_TYPE_BALLOTING_B1].push(response.data);
            }

            if(type == self.PROPERTY_ASSET_TYPE_BALLOTING_B2){
                if (!_.has(self.assetFiles, self.PROPERTY_ASSET_TYPE_BALLOTING_B2)){
                    self.assetFiles[self.PROPERTY_ASSET_TYPE_BALLOTING_B2] = [];
                }
                self.assetFiles[self.PROPERTY_ASSET_TYPE_BALLOTING_B2].push(response.data);
            }
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
    }

    removeAsset(asset, type, idx) {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {

                let url = 'sec/developer/properties/' + self.property.id + '/assets/' + asset.id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Image removed successfully.');

                    self.assetFiles[type].splice(idx, 1); // remove from files index
                });
            }
        );
    }

    switchBallotingOrder(){
        const self = this;

        self.balloting_order_descending = !self.balloting_order_descending;

        if(self.balloting_order_descending){
            self.balloted_eois.reverse();
        }
        else{
            self.balloted_eois = _.sortBy(self.balloted_eois, 'queue_no');
        }
    }

    executeAllInOneBalloting() {
        const self = this;

        let url = 'sec/eois/e-balloting-method-1/' + self.data.property_id + '/' + self.data.launchId;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.danger('Not available for balloting.');
                return;
            }

            self.SSAlertService.success('All-in-One Balloting successfully complete');

            self.ballotedEoisCount = 0;

            jQuery.each(response.data.eois, function (i, eoi) {
                self.findAndUpdateEoi(eoi.eoi_no, eoi.ballot_no);
            });
            self.sortEois();
        });
    }

    executeOneByOneBalloting() {
        const self = this;

        self.STOP_AUTO_DRAW = false;
        self.draw_option_value = '1';

        self.setDefaultOption();
    }

    executeResetBalloting() {
        const self = this;

        let url = 'sec/eois/reset-queue/' + self.data.property_id + '/' + self.data.launchId;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.danger('Some error in Reset Balloting! Please contact support. ('+response.sub_code+')');
                return;
            }
            self.SSAlertService.success('Balloting numbers are removed successfully.');
            self.showLuckyBuyerErrorMessage = null;
            self.currentBallotedEois = [];
            self.showLuckyBuyer = false;
            self.getAllEois();
        });
    }

    executeGetNextLuckyBuyer(draw_limit) {
        const self = this;

        let url = 'sec/eois/e-balloting-method-2/' + self.data.property_id + '/' + self.data.launchId;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            self.currentBallotedEois = [];
            self.stopAnimationSound();

            if(response.data.eois && response.data.eois.length){
                if(self.show_fireworks){
                    self.startFireworks();
                }

                self.$timeout(function() {
                    self.showLuckyBuyer = true;
                    self.stopFireworks();
                }, self.show_fireworks? self.fireworks_duration : 0);
            }

            if (response instanceof Error) {
                self.SSAlertService.danger('Not available for balloting.');
                return;
            }
            
            if (!response.data.eois || !response.data.eois.length) {
                self.showLuckyBuyer = true;
                self.STOP_AUTO_DRAW = true;
                self.AUTO_DRAW_MODE = false;
                // self.draw_option_value = '1'; // WEB-3195
                self.showLuckyBuyerErrorMessage = 'No More EOI is available to set the ballot no.';
                return;
            }

            jQuery.each(response.data.eois, function (i, eoi) {
                self.currentBallotedEois.push(self.findAndUpdateEoi(eoi.eoi_no, eoi.ballot_no));
            });

            if(self.currentBallotedEois && self.currentBallotedEois.length){
                self.balloting_winner_exist = true;

                self.$timeout(function() {
                    jQuery.each(self.currentBallotedEois, function (i, eoi) {
                        eoi.spinner_exist = true;
                    });

                }, self.show_fireworks? self.fireworks_duration : 0);

                let _eoi_no = self.currentBallotedEois[0].eoi_no;
                let eoi_no_arr = _eoi_no.split('');

                if((_eoi_no && self.max_eoi_no_length) && self.max_eoi_no_length > _eoi_no.length){
                    eoi_no_arr = self.padRow(_eoi_no.split(''));
                }

                self.$timeout(function() {
                    self.updateBallotingRow('second_', self.second_balloting_row, false, eoi_no_arr);

                    self.checkAutoDraw(draw_limit);

                }, self.animation_speed);
            }

            self.sortEois();
        });
    }

    getAllEois() {
        const self = this;

        self.first_balloting_row = [];
        self.second_balloting_row = [];
        self.third_balloting_row = [];
        self.balloting_winner_exist = false;

        let url = 'sec/eois';
        let params = {
            property_id: self.data.property_id,
            property_launch_id: self.data.launchId,
            include: "brokers, buyers",
            status: self.EOI_STATUS_VERIFIED + "," + self.EOI_STATUS_REGISTERED,
            limit: 10000
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.data.eois = response.data.eois;
            self.data.buyers = response.data.buyers;
            self.data.users = response.data.users;

            self.totalEoisCount = self.data.eois.length;
            self.ballotedEoisCount = 0;

            self.totalSingleEoisCount = 0;
            self.ballotedSingleEoisCount = 0;

            self.totalBulkEoisCount = 0;
            self.ballotedBulkEoisCount = 0;
            self.max_eoi_no_length = 10; // WEB-3197 - Show 10 column by default

            // Parse data
            if(self.data.eois && self.data.eois.length > 0){

                var _eoi = self.data.eois.find(x => x.queue_no == null || x.queue_no == 0);

                if(_eoi){
                    self.first_balloting_row = _eoi.eoi_no.split('');
                    // self.max_eoi_no_length = _eoi.eoi_no.length; // WEB-3197
                }

                jQuery.each(self.data.eois, function (i, eoi) {

                    if(eoi.type == self.EOI_TYPE_SINGLE_PURCHASE){
                        self.totalSingleEoisCount += 1;
                    }
                    else if(eoi.type == self.EOI_TYPE_MULTIPLE_PURCHASE){
                        self.totalBulkEoisCount += 1;
                    }

                    eoi.buyer_name = self.getBuyerNames(eoi.buyers);
                    eoi.broker_name = self.getBrokerNames(eoi.brokers);

                    if(self.max_eoi_no_length < eoi.eoi_no.length){
                        self.max_eoi_no_length = eoi.eoi_no.length;
                    }

                    if (eoi.queue_no) {

                        if(eoi.type == self.EOI_TYPE_SINGLE_PURCHASE){
                            self.ballotedSingleEoisCount += 1;
                        }
                        else if(eoi.type == self.EOI_TYPE_MULTIPLE_PURCHASE){
                            self.ballotedBulkEoisCount += 1;
                        }

                        self.ballotedEoisCount += 1;
                        self.second_balloting_row = eoi.eoi_no.split('');
                        self.balloting_winner_exist = true;
                        eoi.spinner_exist = true;
                    }
                    else if(eoi.queue_no == null 
                        && _eoi.eoi_no != eoi.eoi_no
                        && self.third_balloting_row.length == 0){
                        self.third_balloting_row = eoi.eoi_no.split('');
                    }
                });
            }

            if(self.first_balloting_row.length == 0){
                self.first_balloting_row = 'ABC1234XYZ'.split('');
            }
            if(self.second_balloting_row.length == 0){
                self.second_balloting_row = self.first_balloting_row;
            }
            if(self.third_balloting_row.length == 0){
                self.third_balloting_row = self.first_balloting_row;
            }

            self.equalizeRows();
       
            self.sortEois();
        });
    }

    sortEois(){
        const self = this;

        self.all_balloted_eois = [];

        $.each(self.data.eois, function(i, eoi){
            if(eoi.queue_no){
                self.all_balloted_eois.push(eoi);
            }
        });

        if(self.balloting_order_descending){
            self.all_balloted_eois = _.sortBy(self.all_balloted_eois, 'queue_no');
            self.all_balloted_eois.reverse();
        }
        else{
            self.all_balloted_eois = _.sortBy(self.all_balloted_eois, 'queue_no');
        }

        self.balloted_eois = angular.copy(self.all_balloted_eois);

        self.loadEois();
    }

    checkAutoDraw(draw_limit){
        const self = this;

        draw_limit--;
        if(!self.STOP_AUTO_DRAW && draw_limit > 0){
            self.$timeout(function() {
                self.AUTO_DRAW_COUNTER++;
                self.btnGetNextLuckyBuyer(draw_limit);
            }, self.show_fireworks? self.fireworks_duration+(self.fireworks_duration/2) : 1500);
        }
        else{
            self.AUTO_DRAW_MODE = false;
            self.STOP_AUTO_DRAW = false;
            // self.draw_option_value = '1'; // WEB-3195
        }
    }

    /**
     * Returns leading alphabet characters of a string; set getTailing flag to get trailing ones instead.
     * @param str
     * @param getTrailing
     * @returns {string}
     */
    getAlphabetsFromString(str, getTrailing = false) {
        const self = this;

        let match = getTrailing? str.match(/[a-zA-Z]+$/): str.match(/^[a-zA-Z]+/);
        if (match) { return match[0]; } // Return leading or tailing alphabet chracters if found
        return ""; // Return an empty string if no leading alphabets are found
    }

    /**
     * Utility: converts array to string
     * @param arr
     * @returns {*|string}
     */
    arrToString(arr) {
        return Array.isArray(arr)? arr.join("") : "";
    }

    /**
     * Helper: pad a row (array) based on leading/trailing alphabet length
     * @param row
     * @returns {any[]|*}
     */
    padRow (row) {
        const self = this;

        if (row && row.length >= 10) { return row; }

        let str = Array.isArray(row) ? self.arrToString(row) : "";

        // Get leading and trailing alphabet sequences
        const leading = self.getAlphabetsFromString(str, false);
        const trailing = self.getAlphabetsFromString(str, true);

        // Calculate how many "-" to add
        const leadingNeeded = leading.length < 3 ? 3 - leading.length : 0;
        const trailingNeeded = trailing.length < 3 ? 3 - trailing.length : 0;

        // Add "-" in front and/or at the end
        if (leadingNeeded > 0) {
            row = Array(leadingNeeded).fill("-").concat(row);
        }
        if (trailingNeeded > 0) {
            row = row.concat(Array(trailingNeeded).fill("-"));
        }

        return row;
    };

    /**
     * Pad all 3 rows for bllot spinner with '-' bssed on leading oe trailing alphabets
     */
    equalizeRows() {
        const self = this;

        self.first_balloting_row = self.padRow(self.first_balloting_row);
        self.second_balloting_row = self.padRow(self.second_balloting_row);
        self.third_balloting_row = self.padRow(self.third_balloting_row);
    }

    exportEois() {
        const self = this;

        let url = "sec/developer/eois/download?property_id=" + self.data.property_id + "&property_launch_id=" + self.data.launchId + "&status=" + self.eoisStatuses.join();
        self.$window.location.href = self.SSHttpService.getApiURL(url);

        self.SSAlertService.success('Success!', 'EOIs are exported successfully.');
    }

    // Button Actions
    //----------------------------------------------

    // Fullscreen
    wakeLockExitHandler(){
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement){
            // Run code on exit
            releaseWakeLock();
        }
    }

    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();

            releaseWakeLock();
            document.removeEventListener("fullscreenchange", self.wakeLockExitHandler);

            self.is_full_screen = false;
        } else {
            if (!$event) return;

            if (typeof $event == "string") {
                self.Fullscreen.enable(document.getElementById($event));
            } else if ($event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable($event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable($event.currentTarget);
            }

            if (document.addEventListener) {
                document.removeEventListener("fullscreenchange", self.wakeLockExitHandler);
                document.addEventListener('fullscreenchange', self.wakeLockExitHandler, false);
            }

            requestWakeLock();
            self.is_full_screen = true;
        }
    }

    handleKeyShortCuts() {
        const self = this;

        let ESC_KEY_CODE = 27;

        // DRAW
        let ENTER_KEY_CODE = 13;
        let A_LETTER_CODE = 65;
        let D_LETTER_CODE = 68;

        // STOP
        let S_LETTER_CODE = 83;
        let DELETE_KEY_CODE = 46;
        let BACKSPACE_KEY_CODE = 8;

        // NUMBERS
        let KEYCODE_NUMBERS = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
        let keyNumbers = '';
        let lastKeyPressedTime = null;

        $(document).keyup(function (event) {
            if (self.showOneByOneBallotingPage) {

                // Combine number keys if pressed together within a sec
                if ($.inArray(event.keyCode, KEYCODE_NUMBERS) !== -1) {
                    let keyPressedTime = new Date();
                    if (lastKeyPressedTime && keyPressedTime.getTime() - lastKeyPressedTime.getTime() < 1000) {
                        keyNumbers += String.fromCharCode(event.keyCode);
                    } else {
                        keyNumbers = String.fromCharCode(event.keyCode);
                    }
                    lastKeyPressedTime = keyPressedTime;
                } else {
                    keyNumbers = '';
                }

                if (event.keyCode === D_LETTER_CODE
                    || event.keyCode === ENTER_KEY_CODE
                ) {
                    self.btnGetNextLuckyBuyer(self.draw_option_value);

                } else if (self.AUTO_DRAW_MODE
                    && (event.keyCode === S_LETTER_CODE
                        || event.keyCode === BACKSPACE_KEY_CODE
                        || event.keyCode === DELETE_KEY_CODE)
                ) {
                    self.STOP_AUTO_DRAW = true;

                } else if (event.keyCode === A_LETTER_CODE) {
                    keyNumbers = '10000';
                }

                // Draw Multiple
                if ($.inArray(keyNumbers, ['1', '10', '50', '100', '10000']) !== -1) {
                    self.$timeout(function () {
                        self.draw_option_value = keyNumbers;
                    });
                }
            }
        });

        // Listen to FBFullscreen.change event and perform Fullscreen cancel changes accordingly
        self.$rootScope.$on("FBFullscreen.change", function (event, isEnabled) {
            if (!isEnabled) {
                self.$timeout(function () {
                    self.Fullscreen.cancel();
                    self.is_full_screen = false;
                });
            }
        });
    }

    btnAllInOneBalloting() {
        const self = this;

        if (self.ballotedEoisCount == self.totalEoisCount) {
            return; // Return if balloting is already done.
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to run the All-in-One Balloting?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self.executeAllInOneBalloting();
            }
        );
    }

    getEois() {
        const self = this;

        let page = 1;
        if (!self.selectedRows) {
            self.limit = self.all_balloted_eois.length;
        } else {
            self.limit = parseInt(self.selectedRows);
        }

        self.loadEois(page);
    }

    // CLIENT SIDE PAGINATION
    loadEois(page) {
        const self = this;

        let eois = angular.copy(self.all_balloted_eois);

        let limitIntValue = parseInt(self.limit);
        page = page ? page : self.selectedPage;
        self.offset = (page > 0 ? (page - 1) : 0) * limitIntValue;
        self.count = eois.length;

        self.balloted_eois = eois.slice(self.offset, limitIntValue + self.offset);

        // SET 'CURRENT SELECTED EOIS' COUNT
        if (limitIntValue < self.all_balloted_eois.length) {
            self.selected_eois_count = limitIntValue;
        } else {
            self.selected_eois_count = self.all_balloted_eois.length;
        }

        if (self.count == 0) {
            return;
        }

        self.selectedPage = Math.floor(self.offset / limitIntValue) + 1;

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        self.total_pages = Math.ceil(self.count / limitIntValue);
        self.setTotalPagesOptions(self.total_pages);
    }

    setTotalPagesOptions(TOTAL_PAGES) {
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for (var index = 0; index < TOTAL_PAGES; index++) {
            self.TOTAL_PAGES_OPTIONS.push(index);
        }
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.offset = self.offset - parseInt(self.limit);
        self.loadEois();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.offset = self.offset + parseInt(self.limit);
        self.loadEois();
    }

    gotoPage(pageNum) {
        const self = this;

        self.loadEois(pageNum);
    }

    btnOneByOneBalloting() {
        const self = this;

        if (self.ballotedEoisCount == self.totalEoisCount) {
            return; // Return if balloting is already done.
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to run the One-by-One Balloting?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self.executeOneByOneBalloting();
                self.currentBallotedEois = [];
                self.showBallotingOptionsPage = false;
                self.showOneByOneBallotingPage = true;
            }
        );
    }

    btnManualBalloting(){
        const self = this;

        if (self.ballotedEoisCount == self.totalEoisCount) {
            return; // Return if balloting is already done.
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to do the Manual Balloting?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self.currentBallotedEois = [];
                self.showBallotingOptionsPage = false;
                self.showManualBallotingPage = true;
            }
        );
    }

    btnResetBalloting() {
        const self = this;

        if (!self.ballotedEoisCount) {
            return; // Return if balloting is not started.
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to reset the previously done balloting?\n' +
            'All the balloting data will be deleted.\n\n' +
            'Note: This action is not reversible.',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self.executeResetBalloting();
            }
        );
    }

    onScanning() {
        const self = this;
    
        self.hideModals();
        self.eoiNumFieldError = '';
        self.eoi_num = '';
    
        self.scanningModal = true;
        $('#salesRegistrationModal').modal('show');
    
        $('#salesRegistrationModal').on('shown.bs.modal', function() {
          $('#eoiScan').focus();
        })
    }

    onQueueNumber(){
        const self = this;

        self.eoiScanToQueueError = '';
        self.queue_scan_eoiId = '';
        self.scanQueueModal = true;
        $('#salesScanQueueModal').modal('show');

        $('#salesScanQueueModal').on('shown.bs.modal', function() {
          $('#eoiQueue').focus();
        })
    }

    registerEoi(){
        const self = this;
    
        self.eoiNumFieldError = '';
        let eoiNo = self.eoi_num;
    
        try{
          
          // Property short_code can be of 2 or 3 digits
          // So determine the length for 'EOI REGISTRATION' number
          if(self.eoi_num.length === self.code_length){
            self.updateEoiStatus(self.eoi_num, self.EOI_STATUS_REGISTERED);
          }
        }
        catch(ex){
          console.log(ex);
        }
    }

    updateEoiStatus(eoi_id, eoi_status){
        const self = this;
    
        let url = 'sec/eois/'+ eoi_id + '/status?property_id='+ self.property.id;
        let param = {
            status: eoi_status
        };
        loading(true);
        self.SSHttpService.putAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                //self.SSAlertService.parseAndDisplayError(response);
                self.eoiNumFieldError = response.message;

                self.$timeout(function() { // re-focus field
                    $('#eoiScan').focus();
                }, self.eoi_num);
                return;
            }
            // self.hideModals();
            self.SSAlertService.success('Success!', 'EOI status updated successfully');
            self.getAllEois();

            /* Clear field and re-focus for next scan */
            self.eoi_num = "";
            self.$timeout(function() {
                $('#eoiScan').focus();
            }, self.eoi_num);
        });
    }
    
    assignQueueNum(){
        const self = this;

        if(self.queue_scan_eoiId.length !== self.code_length){
            return;
        }

        self.eoiScanToQueueError = '';
        let url = 'sec/eois/'+ self.queue_scan_eoiId + '/queue?property_id='+ self.property.id;
        loading(true);
        self.SSHttpService.putAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(response.message){
                    self.eoiScanToQueueError = response.message;
                }else{
                    self.SSAlertService.parseAndDisplayError(response);
                }

                self.$timeout(function() { // re-focus field
                    $('#eoiQueue').focus();
                }, self.queue_scan_eoiId);
                return;
            }
            self.SSAlertService.success('Success!', 'EOI queue number updated successfully');
            if(response.data && response.data.eoi){
                response.data.eoi.spinner_exist = true;
                self.findAndUpdateEoi(response.data.eoi.eoi_no, response.data.eoi.queue_no);
            }
            self.sortEois();

            /* Clear field and re-focus for next scan */
            self.queue_scan_eoiId = "";
            self.$timeout(function() {
                $('#eoiQueue').focus();
            }, self.queue_scan_eoiId);
        });
    }

    btnBack() {
        const self = this;

        self.showBallotingOptionsPage = true;
        self.showOneByOneBallotingPage = false;
        self.showManualBallotingPage = false;
        self.showUnitPlacementPage = false;
    }

    btnGetNextLuckyBuyer(draw_limit) {
        const self = this;

        if(draw_limit && !self.AUTO_DRAW_MODE){
            draw_limit = typeof draw_limit == 'string'? parseInt(draw_limit) : draw_limit;
            self.AUTO_DRAW_MODE = true;
            self.AUTO_DRAW_COUNTER = 1;
            self.AUTO_DRAW_LIMIT = angular.copy(draw_limit);
        }

        self.mouse_click_sound.play();
        self.balloting_winner_exist = false;
        self.showLuckyBuyer = false;

        try{
            self.animateBalloting();
            if(self.play_animation_sound){
                self.animation_sound.play();
            }
        } catch(ex){
            console.log(ex);
        }

        self.$timeout(function () {
            self.executeGetNextLuckyBuyer(draw_limit);
        }, 1200);
    }

    // Helper Functions
    //----------------------------------------------

    initSoundEffect(url){
        let sound = null;

        sound = document.createElement("audio");
        sound.src = url;

        sound.setAttribute("preload", "auto");
        sound.setAttribute("controls", "none");
        sound.style.display = "none";
        document.body.appendChild(sound);

        return sound;
    }

    stopAnimationSound(){
        const self = this;

        try{
            self.animation_sound.pause();
            self.animation_sound.currentTime = 0;
        } catch(ex){
            console.log(ex);
        }
    }

    startFireworks(id_prefix = null){
        const self = this;

        try{
            $('#'+(id_prefix||'')+'fireworks').fireworks();
            self.fireworks_sound.play();
        }
        catch(ex){
            console.log(ex);
        }
    }

    stopFireworks(id_prefix = null){
        const self = this;

        try{
            $('#'+(id_prefix||'')+'fireworks').fireworks('destroy');
            self.fireworks_sound.pause();
            self.fireworks_sound.currentTime = 0;
        }
        catch(ex){
            console.log(ex);
        }
    }

    getLogoUrl(property_assets){
        const self = this;

        let logo_url = null;

        if(!property_assets){
            return logo_url;
        }

        let logo = property_assets.find(x => x.type == self.PROPERTY_ASSET_TYPE_LOGO_IMAGE);
        if(logo){
            logo_url = self.SSAppService.getAssetUrl(logo.file_uri);
        }

        return logo_url;
    }

    initAsciiCodes(){
        const self = this;

        self.ascii_numbers = [];
        self.ascii_alphabets = [];

        for(var index = 48; index <= 57; index++){
            self.ascii_numbers.push(index);
        }

        for(var index = 65; index <= 90; index++){
            self.ascii_alphabets.push(index);
        }
    }

    updateBallotingRow(id_prefix, balloting_row, toggle_code = true, updated_row = null){
        const self = this;

        if(!id_prefix || !balloting_row){
            console.log('ID/Balloting row is empty.');
            return;
        }

        for(var index = 0; index < balloting_row.length; index++){
            var code = updated_row? updated_row[index] : balloting_row[index];

            if(toggle_code){
                code = self.toggleAsciiCode(code);
            }

            $("#"+id_prefix+balloting_row[index]+"_"+index).text(code);
        }
    }

    animateBalloting(id_prefix = null, counter = 1){
        const self = this;

        var interval_id = setInterval(function(){

            self.updateBallotingRow((id_prefix||'')+ 'first_', self.first_balloting_row);
            self.updateBallotingRow((id_prefix||'')+ 'second_', self.second_balloting_row);
            self.updateBallotingRow((id_prefix||'')+ 'third_', self.third_balloting_row);

            counter++;                  
            if (counter < self.animation_duration && !self.showLuckyBuyer) {           
              self.animateBalloting(null, counter);
            }
            else{
                clearInterval(interval_id);
            }

        }, self.animation_speed);
    }

    toggleAsciiCode(code){
        const self = this;

        if($.inArray(code.charCodeAt(0), self.ascii_numbers) !== -1){
            code = self.getRandomCode(48, 57, code.charCodeAt(0))
        }
        else if($.inArray(code.charCodeAt(0), self.ascii_alphabets) !== -1){
            code = self.getRandomCode(65, 90, code.charCodeAt(0))
        }
        else if(code.charCodeAt(0) == 45){
            // "45": "-"
            code = self.getRandomCode(65, 90, code.charCodeAt(0))
        }

        return code;
    }

    getRandomCode(min, max, number){

        var code = Math.floor(Math.random() * (max - min + 1)) + min;

        while(code == number){
            code = Math.floor(Math.random() * (max - min + 1)) + min;
        }

        return String.fromCharCode(code);
    }

    findAndUpdateEoi(eoi_no, queue_no) {
        const self = this;

        let eoi = null;

        jQuery.each(self.data.eois, function (i, _eoi) {
            if (eoi_no == _eoi.eoi_no) {
                eoi = _eoi;

                if(!_eoi.queue_no){
                    self.ballotedEoisCount += 1;
                    if(eoi.type == self.EOI_TYPE_SINGLE_PURCHASE){
                        self.ballotedSingleEoisCount += 1;
                    }
                    else if(eoi.type == self.EOI_TYPE_MULTIPLE_PURCHASE){
                        self.ballotedBulkEoisCount += 1;
                    }
                }

                _eoi.queue_no = queue_no;
            }
        });

        return eoi;
    }

    getBuyerNames(eoiBuyers) {
        const self = this;

        let buyersName = [];

        jQuery.each(eoiBuyers, function (i, eoiBuyer) {
            jQuery.each(self.data.buyers, function (i, buyer) {
                if (eoiBuyer.id == buyer.id) {
                    buyersName.push(self.getBuyerName(buyer));
                }
            });
        });

        return buyersName.join(', ');
    }

    getBuyerName(buyer){
        const self = this;

        let name = "--";
        if(!buyer){
            return name;
        }

        let user = buyer.individual? buyer.individual : buyer.company;

        if(user && (user.first_name || user.last_name || user.display_name || user.name)){
            if(user.name){  // In case, if buyer is 'company'
                name = user.name;
            }
            else{
                name = (user.first_name? user.first_name : "") + " " + (user.last_name? user.last_name : "");
            }
            if(!name.trim()){
                name = user.display_name? user.display_name : "";
            }
        }

        return name.trim()? name.trim() : "--";
    }

    getBrokerNames(eoiBrokers) {
        const self = this;

        let brokersName = [];

        jQuery.each(eoiBrokers, function (i, eoiBroker) {
            jQuery.each(self.data.users, function (i, user) {
                if (eoiBroker.broker_user_id == user.id) {
                    brokersName.push(user.first_name + ' ' + user.last_name);
                }
            });
        });

        return brokersName.join(', ');
    }

    // initDrawOptionValues(){
    //     const self = this;

    //     self.DRAW_OPTION_VALUES = [];

    //     self.DRAW_OPTION_VALUES.push({id: '', name: 'Draw Multiple'});
    //     self.DRAW_OPTION_VALUES.push({id: '5', name: 'Draw 5'});
    //     self.DRAW_OPTION_VALUES.push({id: '10', name: 'Draw 10'});
    //     self.DRAW_OPTION_VALUES.push({id: '50', name: 'Draw 50'});
    //     self.DRAW_OPTION_VALUES.push({id: '100', name: 'Draw 100'});
    //     self.DRAW_OPTION_VALUES.push({id: '10000', name: 'Draw All'});
    // }

    setDefaultOption(){
        const self = this;

        // Remove empty option
        $('select option')
        .filter(function() {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
       .remove();

    }

    hideModals() {
        const self = this;

        if ($('#salesRegistrationModal').is(':visible')) $('#salesRegistrationModal').modal('hide');
        if ($('#salesScanQueueModal').is(':visible')) $('#salesScanQueueModal').modal('hide');
    }

    updateSettings(){
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
             $('#updateSettingsModal').modal('show');
        });
    }

    /** WEB-2843 E-Balloting - Unit Placement Method - START **/
    btnUnitPlacement(){
        const self = this;

        if (self.ballotedEoisCount == self.totalEoisCount) {
            return; // Return if balloting is already done.
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to do the Unit Placement?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                if(!self.property){
                    console.warn("Property info not available.")
                    return;
                }

                self.getAgenciesByProperty(self.property.id, self.first, 'initUnitPlacement')
                self.getUnits('initUnitPlacement');

                self.currentBallotedEois = [];
                self.showBallotingOptionsPage = false;
                self.showUnitPlacementPage = true;
            }
        );
    }

    getAgenciesByProperty(PropertyId, type, loadingGroup = null) {
        const self = this;

        let url = 'sec/developer/agencies/';
        let param = {
            property_id: PropertyId
        };
        loading(true, null, null, loadingGroup);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false, null, null, loadingGroup);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if ( !response.data ) { return; }

            self.property_agencies = (response && response.data && response.data.property_agencies)?
                    response.data.property_agencies : null;
        });
    }

    getPhase(show_loading = true) {
        const self = this;
        if (!self.property)
            return;

        self.phase = null;
        self.phase_master = null;
        self.availability = {};
        self.propertyLaunch = {};
        let EoiPropertyLaunch = [];

        if(show_loading){
            loading(true);
        }
        let url = 'sec/developer/properties/' + self.property.id + '/launches';
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.phase = response.data;
            self.phase_master = angular.copy(self.phase);
            self.propertyLaunches = (response.data)? response.data.property_launches : null;
            self.current_property_launch = self.propertyLaunches? self.propertyLaunches
                    .find(launch => launch.id == self.data.launchId) : '';

            jQuery.each(self.propertyLaunches, function (i, propertyLaunch) {
                if (EoiPropertyLaunch) {
                    EoiPropertyLaunch = EoiPropertyLaunch.concat(propertyLaunch.id);
                } else {
                    EoiPropertyLaunch = propertyLaunch.id;
                }
            });

            if (EoiPropertyLaunch) {
                self.EoiPropertyLaunch = self.getUniqueArray(EoiPropertyLaunch);
            }
        });
    }

    getUnits(loadingGroup = null) {
        const self = this;
        if (!self.property.id)
            return;

        self.units = null;

        loading(true, null, null, loadingGroup);
        let url = 'properties/' + self.property.id + '/stacks';
        let params = {
            /*'return_property': true,
            'property_columns': 'id,named_id,name,type,product_type,status,location,country,region',*/
            'return_stack': true,
            'stack_columns': 'id,named_id,name',
            'include_units': true,
            'unit_columns': 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,status,size_ft2'
            /*'unit_columns': 'id,named_id,floor_no,unit_no,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'*/
        };
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false, null, null, loadingGroup);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response && response.data && response.data.property_stacks){
                self.units = response.data.property_stacks;
                self.getPropertyStacks(self.property.id);
            }else {
                console.warn("Units info is not valid");
            }
        });
    }

    getPropertyStacks(propertyId) {
        const self = this;

        self.stacks = self.units;
        self.stacks_promocodes = angular.copy(self.units);

        self.processServerData();
        self.getPropertyUnitTypes();

        self.isEoiAccessible = !!self.SSUserService.getActivePropertyLaunchForEoiCreate(self.property, 'EOI');

        self.getUnitsEoi(self.property.id, self.first, self.data.launchId);
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            // No need to filter available units
            stack.availableUnits = stack.units;// self.filterAvailableUnits(stack.units);
            self.availableUnits = stack.units; //stack.availableUnits;
            self.loadUnits();
        });

        jQuery.each(self.stacks_promocodes, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            // No need to filter available units
            stack.availableUnits = stack.units;// self.filterAvailableUnits(stack.units);
            self.availableUnits = stack.units; //stack.availableUnits;
            self.loadUnits();
        });

        // Select first stack by default
        if (self.stacks.length > 0) {
            self.selectedStackId = '';
            self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
        }

        if (self.stacks_promocodes.length > 0) {
            self.selectedStackIdPromoCode = '';
            self.selectedStackIdPromoCode = (self.selectedStackIdPromoCode) ? self.selectedStackIdPromoCode : self.stacks_promocodes[0].id;
        }
        self.SSAppService.isPageLoaded = true;
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (self.propertyUnitCategories.indexOf(category) === -1) {
                    self.propertyUnitCategories.push(category);
                }
            });
        });
    }

    /** WEB-2843 E-Balloting - Unit Placement Method
      * Remove if not in use
    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED]; // self.UNIT_STATUS_RESERVED, self.UNIT_STATUS_DRAFT
        let filtered = [];

        _.each(units, function (unit) {
            if (statuses.indexOf(unit.status) !== -1)
                filtered.push(unit);
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            })
        }

        return filtered;
    }**/

    loadUnits() {
        const self = this;

        self.units = [];
        self.availableUnits = self.SSUtilService.getSortedUnits(self.availableUnits, false, 'named_id');
        self.count = self.availableUnits.length;
        self.pages = Math.ceil(self.count / self.apiLimit);
        self.heatmapListSelectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        self.pagesArr = [];

        /** Sort units based on eoi count **/
        let sortedUnits = self.availableUnits;
        if(self.EoiUnitsCount){
            sortedUnits = sortedUnits.map( unit =>{
                unit["eois"] = self.EoiUnitsCount[unit.id] || 0;
                return unit;
            })
            sortedUnits = sortedUnits.sort((a, b) => b.eois - a.eois) // Sort decending
        }

        for (var i = 0; i < self.pages; i++) {
            self.pagesArr.push(i);
        }
        for (var i = 0; i < self.apiLimit; i++) {
            if (self.apiOffset + i < self.count) {
                self.units.push(sortedUnits[self.apiOffset + i]);
            }
        }
    }

    getUnitsEoi(PropertyId, type, LaunchId) {
        const self = this;

        self.total_eois_by_phase = 0;
        self.getEBallotingValidation();
        let EoiUnits = null;
        self.property_sid = PropertyId;
        self.EoiUnitsCount = {};
        let Eoibrokers = [];
        let Eoiagencies = [];
        self.unitAgencies = [];
        self.duplicateCheque = [];
        let agency = [];

        if (jQuery.inArray(parseInt(LaunchId), self.EoiPropertyLaunch) === -1) {
            alert("The selected Launch Id does not have Eoi");
            return;
        }

        if (!PropertyId && self.property) { // If PropertyId not found, set from property object
            PropertyId = self.property.id;
        }

        let url = 'sec/eois';
        let params = {
            property_id: PropertyId,
            include: "brokers, promotion_code, sale_status",
            property_launch_id: LaunchId,
            limit: 10000,
            status: "30,60"
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.unitEoiByPhase = response.data;
            self.allEoisByPhase = self.unitEoiByPhase.eois;

            // get the Eoi Details
            jQuery.each(self.allEoisByPhase, function (i, Eoi) {
                if (Eoi.property_launch_id === parseInt(LaunchId)) {
                    self.total_eois_by_phase += 1;

                    jQuery.each(Eoi.brokers, function (i, broker) {
                        jQuery.each(self.unitEoiByPhase.brokers, function (i, brokerId) {
                            if (broker.broker_user_id === brokerId.user_id) {
                                broker.agency_id_found = brokerId.agency_id;
                                return false;
                            }
                        });

                        if (self.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                            Eoibrokers.push({
                                'broker_user_id': broker.broker_user_id,
                                'eoi': Eoi
                            });
                            return false;
                        }
                    });

                    let eoiUnitsChoices = [];
                    try {
                        eoiUnitsChoices = JSON.parse(Eoi.units); // [[201,202,205],[203,201]]
                    } catch(ex){
                        console.warn(ex);
                    }

                    $.each(eoiUnitsChoices, function(i, _eoiUnitChoices) {
                        $.each(_eoiUnitChoices, function(j, _unitId) {
                            if (type === 2 && j === 0) { // First Choice
                                EoiUnits = EoiUnits ? (EoiUnits + ',' + _unitId) : _unitId;
                            } else if (type === 1) { // All Choices
                                EoiUnits = EoiUnits ? (EoiUnits + ',' + _unitId) : _unitId;
                            }
                        });
                    });
                }
            });

            //get the agency details
            jQuery.each(Eoibrokers, function (i, broker) {
                jQuery.each(self.unitEoiByPhase.brokers, function (i, eoi_broker) {
                    if (broker.broker_user_id === eoi_broker.user_id) {
                        Eoiagencies.push({'agency_id': eoi_broker.agency_id, 'eoi': broker.eoi});
                    }
                });

            });

            if (EoiUnits && (EoiUnits.toString().indexOf(',') > -1)) {
                self.EoiUnits = EoiUnits.split(",").map(Number);
            } else {
                self.EoiUnits = jQuery.makeArray(EoiUnits);
            }

            self.EoiUnitsCount = self.EoiUnits.reduce(function (acc, curr) {
                if (typeof acc[curr] == 'undefined') {
                    acc[curr] = 1;
                } else {
                    acc[curr] += 1;
                }

                return acc;
            }, {});

            self.EoiAgencyCount = {};
            var verified_eoi_count = 0;
            var registered_eoi_count = 0;
            var completed_eoi_count = 0;
            var balloted_eoi_count = 0;
            var unit_allocated_eoi_count = 0;
            var completed_eois_count = 0;
            var total = 0;

            $.each(Eoiagencies, function (index, agency) {
                if (typeof self.EoiAgencyCount[agency.agency_id] == 'undefined') {
                    self.EoiAgencyCount[agency.agency_id] = {
                        'total': 1,
                        'verified_eoi_count': self.isVerifiedEoi(agency.eoi) ? 1 : 0,
                        'registered_eoi_count': self.isRegisteredEoi(agency.eoi) ? 1 : 0,
                        'completed_eoi_count': self.isCompletedEoi(agency.eoi) ? 1 : 0,
                        'balloted_eoi_count': self.isBallotedEoi(agency.eoi) ? 1 : 0,
                        'unit_allocated_eoi_count': self.isUnitAllocatedEoi(agency.eoi) ? 1 : 0,
                        'completed_eois_count': self.isCompletedEoi(agency.eoi) ? 1 : 0,
                    };
                } else {
                    total = (self.EoiAgencyCount[agency.agency_id].total += 1);

                    verified_eoi_count = self.isVerifiedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].verified_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].verified_eoi_count;
                    registered_eoi_count = self.isRegisteredEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].registered_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].registered_eoi_count;
                    completed_eoi_count = self.isCompletedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].completed_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].completed_eoi_count;
                    balloted_eoi_count = self.isBallotedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].balloted_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].balloted_eoi_count;
                    unit_allocated_eoi_count = self.isUnitAllocatedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].unit_allocated_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].unit_allocated_eoi_count;
                    completed_eois_count = self.isCompletedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].completed_eois_count += 1) : self.EoiAgencyCount[agency.agency_id].completed_eois_count;

                    self.EoiAgencyCount[agency.agency_id] = {
                        'total': total,
                        'verified_eoi_count': verified_eoi_count,
                        'registered_eoi_count': registered_eoi_count,
                        'completed_eoi_count': completed_eoi_count,
                        'balloted_eoi_count': balloted_eoi_count,
                        'unit_allocated_eoi_count': unit_allocated_eoi_count,
                        'completed_eois_count': completed_eois_count,
                    };
                }
            });

            jQuery.each(self.EoiAgencyCount, function (i, agencies) {
                agency = {};
                agency.name = self.getagencyname(i);
                agency.count = agencies.total;

                agency.verified_eois = agencies.verified_eoi_count;
                agency.registered_eois = agencies.registered_eoi_count;
                agency.completed_eois = agencies.completed_eoi_count;
                agency.balloted_eois = agencies.balloted_eoi_count;
                agency.unit_allocated_eois = agencies.unit_allocated_eoi_count;
                agency.completed_eois = agencies.completed_eois_count;

                self.unitAgencies.push(agency);
            });

            self.all_agencies_total_eois = 0;
            self.all_agencies_verified_eois = 0;
            self.all_agencies_registered_eois = 0;
            self.all_agencies_balloted_eois = 0;
            self.all_agencies_unit_allocated_eois = 0;
            self.all_agencies_completed_eois = 0;

            // Calculate total count against each agency
            $.each(self.unitAgencies, function (index, obj) {
                self.all_agencies_total_eois += obj.count;
                self.all_agencies_verified_eois += obj.verified_eois;
                self.all_agencies_registered_eois += obj.registered_eois;
                self.all_agencies_balloted_eois += obj.balloted_eois;
                self.all_agencies_unit_allocated_eois += obj.unit_allocated_eois;
                self.all_agencies_completed_eois += obj.completed_eois;
            });

            if(self.viewType === 2){
                self.loadUnits();
            }
        });
    }

    getAgencyByUnit(unitId, type, LaunchId) {
        const self = this;

        let EoiUnits = null;
        let output = "";
        let Eoibrokers = [];
        let Eoiagencies = [];
        let agency = [];
        self.unitAgencies_unit = [];
        self.unitAgencies_change = [];
        self.EoiAgencyCount_unit = {};

        jQuery.each(self.unitEoiByPhase.eois, function (i, Eoi) {
            if (Eoi.property_launch_id == LaunchId) {
                if (Eoi.units) {
                    try{
                        EoiUnits = JSON.parse(Eoi.units);
                    } catch(ex) {}
                }

                if (type === 2) {
                    jQuery.each(EoiUnits, function (i, choices) {
                        if (unitId == choices[0]) {
                            jQuery.each(Eoi.brokers, function (j, broker) {
                                if (self.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                                    Eoibrokers.push(broker.broker_user_id);
                                    return false;
                                }
                            });
                            return false;
                        }
                    });
                } else {
                    let unitChoices = EoiUnits;

                    $.each(unitChoices, function(j, choices){
                        if (jQuery.inArray(unitId, choices) !== -1) {
                            jQuery.each(Eoi.brokers, function (i, broker) {
                                if (self.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                                    Eoibrokers.push(broker.broker_user_id);
                                    return false;
                                }
                            });
                        }
                    });
                }
            }
        });

        jQuery.each(Eoibrokers, function (i, broker) {
            jQuery.each(self.unitEoiByPhase.brokers, function (i, brokerId) {
                if (broker == brokerId.user_id) {

                    if (brokerId.agency_id != '') {
                        Eoiagencies.push(brokerId.agency_id);
                    }
                }
            });
        });

        self.EoiAgencyCount_unit = Eoiagencies.reduce(function (acc, curr) {
            if (typeof acc[curr] == 'undefined') {
                acc[curr] = 1;
            } else {
                acc[curr] += 1;
            }

            return acc;
        }, {});

        jQuery.each(self.EoiAgencyCount_unit, function (i, agencies) {
            agency = {};
            agency.name = self.getagencyname(i);
            agency.count = agencies;
            self.unitAgencies_unit.push(agency);
        });

        jQuery.each(self.unitAgencies_unit, function (i, agn) {
            if (output == '') {
                output = "<p><strong>" + agn.name + "<span>" + agn.count + "</span></strong></p>";
            } else {
                output += "<p><strong>" + agn.name + "<span>" + agn.count + "</span></strong></p>";
            }
        });

        if (output != null) {
            document.getElementById(unitId).innerHTML = output;
        }
    }

    getagencyname(agencyId) {
        const self = this;
        let agencyname = null;

        jQuery.each(self.unitEoiByPhase.agencies, function (i, agencies) {
            if (agencies.id == agencyId) {
                agencyname = agencies.name;
                return false;
            }
        });

        return agencyname;
    }

    getEBallotingValidation() {
        const self = this;

        self.eoiDateCheck = false;
        if (!self.phase_master || !self.phase_master.property_launches) {
            return;
        }

        $.each(self.phase_master.property_launches, function (i, phase) {
            if (phase.id == parseInt(self.data.launchId)) {
                var currentDateUtc = moment().utc().format('YYYY-MM-DD HH:mm:ss')
                var eoiEndDateUtc = moment(phase.eoi_end_date).format('YYYY-MM-DD HH:mm:ss');
                var launchEndDateUtc = moment(phase.launch_end_date).format('YYYY-MM-DD HH:mm:ss');

                if (currentDateUtc > eoiEndDateUtc && currentDateUtc <= launchEndDateUtc) {
                    self.eoiDateCheck = true;
                }
            }
        });
    }

    getAgencyName(agencyId) {
        const self = this;
        if (agencyId == null || agencyId == '' || agencyId == undefined)
            return '';
        let agencyname = '';

        jQuery.each(self.unitEoiByPhase.agencies, function (i, agencies) {

            if (agencies.id == agencyId) {
                agencyname = agencies.name;
                return false;
            }
        });

        return agencyname;
    }

    getEoiCountByUnit(unitId) {
        const self = this;

        if (unitId) {
            return self.EoiUnitsCount[unitId];
        }
    }

    filterLegendEoi(className) {
        var buttons = $("div.dashboard-scroll").find("button");

        //Make all visible
        var invisible_buttons = $("div.dashboard-scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }

        //Highlight legend
        $(".legend-block").removeClass("selected");
        if (className) {
            $(".legend-block[data-legend-class='"+className+"']").addClass("selected");
        }else{
            $(".legend-block[data-legend-class='All']").addClass("selected");
        }
    }

    initEOisStatuses(){
        const self = this;

        self.EOIS_STATUSES = [
            {'id': self.EOI_STATUS_DRAFT, 'name': 'Draft', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_TRANSFERRED, 'name': 'Transferred', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUBMITTED, 'name': 'Submitted', 'className': 'text-success'},
            {'id': self.EOI_STATUS_VERIFIED, 'name': 'Verified', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_WITHDRAWN, 'name': 'Withdrawn', 'className': 'text-success'},
            {'id': self.EOI_STATUS_REJECTED, 'name': 'Rejected', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_REGISTERED, 'name': 'Registered', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUCCESSFUL, 'name': 'Successful', 'className': 'text-success'},
            {'id': self.EOI_STATUS_UNSUCCESSFUL, 'name': 'Unsuccessful', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_COMPLETED, 'name': 'Completed', 'className': 'text-success'},
        ];
    }

    getEoiStatusName(eoiStatus){
        const self = this;

        // Set 'default' value as Draft
        let name = '';

        let status = self.getEoiStatus(eoiStatus);

        if(status){
            name = status.name;
        }

        return name;
    }

    getEoiStatus(eoiStatus){
        const self = this;

        let status = null;
        if(!eoiStatus){
            return status;
        }

        try{
            status = self.EOIS_STATUSES.find(x => x.id == eoiStatus);
        }
        catch(ex){
            console.log(ex);
        }

        return status;
    }

    isVerifiedEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if (eoi.status === self.EOI_STATUS_VERIFIED
            || eoi.status === self.EOI_STATUS_REGISTERED
            || eoi.status === self.EOI_STATUS_SUCCESSFUL
            || eoi.status === self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status === self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isRegisteredEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if (eoi.status === self.EOI_STATUS_REGISTERED
            || eoi.status === self.EOI_STATUS_SUCCESSFUL
            || eoi.status === self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status === self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isCompletedEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if (eoi.status === self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isBallotedEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if ((eoi.status === self.EOI_STATUS_VERIFIED
            || eoi.status === self.EOI_STATUS_REGISTERED
            || eoi.status === self.EOI_STATUS_SUCCESSFUL
            || eoi.status === self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status === self.EOI_STATUS_COMPLETED) && eoi.queue_no != null) {
            return true;
        } else {
            return false;
        }
    }

    isUnitAllocatedEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if (eoi.status === self.EOI_STATUS_SUCCESSFUL) {
            return true;
        } else {
            return false;
        }
    }

    isCompletedEoi(eoi) {
        const self = this;
        if (!eoi) {
            return false;
        }

        if (eoi.status === self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    getUniqueArray(array) {
        var result = [];
        for (var x = 0; x < array.length; x++) {
            if (result.indexOf(array[x]) == -1)
                result.push(array[x]);
        }
        return result;
    }

    /**
     * Unit Placement Balloting code - Start
     **/
    getUnitsPhase(unitId) {
        const self = this;
        let phase_class = null;

        if (self.phase_master) {
            if (typeof self.getHeapMapClass_count(unitId, null) == "undefined") {
                jQuery.each(self.phase_master.property_launches, function (i, phase) {
                    if (phase.units) {
                        if (jQuery.inArray(unitId, phase.units) !== -1) {
                            phase_class = "phase";
                            return false;
                        }
                    }
                });
                return phase_class;
            }
        }
    }

    getHeapMapClass(unitId, unit) {
        const self = this;

        if (jQuery.inArray(unitId, self.EoiUnits) !== -1) {
            var count = self.EoiUnitsCount[unitId];
            var className = ""

            if(unit.status !== self.UNIT_STATUS_LISTED){
                className = "reserved";
            }else if (count > 0 && count < 2) {
                className = "db-cyan";
            } else if (count > 1 && count < 3) {
                className = "db-lt-blue";
            } else if (count < 1) {
                className = "legend-color db-lt-gray";
            } else if (count > 2 && count <= 4) {
                className = "legend-color db-blue";
            } else if (count > 4 && count <= 6) {
                className = "legend-color db-light-navy";
            } else if (count > 6 && count <= 8) {
                className = "legend-color db-dark-navy";
            } else if (count >= 9) {
                className = "legend-color db-darker-navy";
            } else {
                className = "db-lt-gray";
            }

            return className;
        } else {
            if(unit.status !== self.UNIT_STATUS_LISTED && unit.category){
                return "reserved";
            }else{
                return "db-lt-gray";
            }
        }
    }

    getHeapMapClass_count(unitId, unit) {
        const self = this;
        if (self.EoiUnitsCount) {
            return self.EoiUnitsCount[unitId];
        }
    }

    heatmapListPagesGoBack() {
        const self = this;

        self.heatmapListSelectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.loadUnits();
    }

    heatmapListPagesGoNext() {
        const self = this;

        self.heatmapListSelectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.loadUnits();
    }

    heatmapListGotoPage(pageNum) {
        const self = this;

        self.apiOffset = parseInt(pageNum) * self.apiLimit;
        self.loadUnits();
    }

    sortData(sortBy) {
        const self = this;

        self.sortBy = sortBy;

        switch (self.sortBy) {
            case "unit_no":
                self.sortByHeading = "#UNIT NO";
                break;
            case "house_no":
                self.sortByHeading = "HOUSE NO";
                break;
            case "name":
                self.sortByHeading = "TYPE";
                break;
            case "price":
                self.sortByHeading = "$PRICE";
                break;
            default:
                self.sortByHeading = "Sort by...";
                break;
        }

        self.processServerData();
    }

    viewUnit(unit) {
        const self = this;
        window.location.href = '/' + self.property.named_id + '/' + unit.named_id;
    }


    selectUnitForPlacement(unit) {
        const self = this;

        if (jQuery.inArray(unit.id, self.EoiUnits) !== -1 &&
                unit.status === self.UNIT_STATUS_LISTED) {
            var count = self.EoiUnitsCount[unit.id];
            self.showUnitPlacementPage = false;
            self.showUnitPlacementDrawPage = true;

            self.selectedUnitForPlacement = unit;
        }
    }

    btnBackToUnitPlacement(){
        const self = this;

        self.showUnitPlacementPage = true;
        self.showUnitPlacementDrawPage = false;

        self.selectedUnitForPlacement = null;
        self.showLuckyBuyerErrorMessage = null;
        self.showLuckyBuyer = false;

        // Refresh eois when returing to Unit Placement
        self.getUnitsEoi(self.property.id, self.first, self.data.launchId);
    }

    btnGetNextLuckyBuyerForUnitPlacement() {
        const self = this;

        self.mouse_click_sound.play();
        self.balloting_winner_exist = false;
        self.showLuckyBuyer = false;

        try{
            self.animateBalloting("unit_plmt_");
            if(self.play_animation_sound){
                self.animation_sound.play();
            }
        } catch(ex){
            console.log(ex);
        }

        self.$timeout(function () {
            self.executeGetNextLuckyBuyerForUnitPlacement();
        }, 1200);
    }

    executeGetNextLuckyBuyerForUnitPlacement() {
        const self = this;
        self.showLuckyBuyerErrorMessage = null;
        loading(true);
        let url = 'sec/eois/e-balloting-method-3/'+ self.data.property_id +'/'+ self.data.launchId +'/'+ self.selectedUnitForPlacement.id +'?draw=1&restrictToFirstChoice='+self.restrictToFirstChoice;
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            self.currentBallotedEois = [];
            self.stopAnimationSound();
            if(response.data.eois && response.data.eois.length){
                if(self.show_fireworks){
                    self.startFireworks("unit_plmt_");
                }

                self.$timeout(function() {
                    self.showLuckyBuyer = true;
                    self.stopFireworks("unit_plmt_");
                }, self.show_fireworks? self.fireworks_duration : 0);
            }

            if (response instanceof Error) {
                self.SSAlertService.danger('Not available for balloting.');
                return;
            }

            if (!response.data.eois || !response.data.eois.length) {
                self.showLuckyBuyer = true;
                self.STOP_AUTO_DRAW = true;
                self.AUTO_DRAW_MODE = false;
                // self.draw_option_value = '1'; // WEB-3195
                self.showLuckyBuyerErrorMessage = 'No More EOI is available to set the ballot no.';
                return;
            }

            jQuery.each(response.data.eois, function (i, eoi) {
                self.currentBallotedEois.push(self.findAndUpdateEoi(eoi.eoi_no, eoi.ballot_no));
            });

            if(self.currentBallotedEois && self.currentBallotedEois.length){
                self.balloting_winner_exist = true;

                self.$timeout(function() {
                    jQuery.each(self.currentBallotedEois, function (i, eoi) {
                        eoi.spinner_exist = true;
                    });

                }, self.show_fireworks? self.fireworks_duration : 0);

                let _eoi_no = self.currentBallotedEois[0].eoi_no;
                let eoi_no_arr = _eoi_no.split('');

                if((_eoi_no && self.max_eoi_no_length) && self.max_eoi_no_length > _eoi_no.length){
                    eoi_no_arr = self.padRow(_eoi_no.split(''));
                }

                self.selectedUnitForPlacement.status = self.UNIT_STATUS_RESERVED; // Set unit status reserved after balloting

                self.$timeout(function() {
                    self.updateBallotingRow('unit_plmt_second_', self.second_balloting_row, false, eoi_no_arr);

                    self.checkAutoDraw(1);

                }, self.animation_speed);
            }

            self.sortEois();
        });
    }

    loadListView(){
        const self = this;

        self.viewType = 2;
        let selectedStack = self.stacks.find(s => s.id === self.selectedStackId);
        self.availableUnits = selectedStack.availableUnits;
        self.loadUnits();
    }
    /** WEB-2843 E-Balloting - Unit Placement Method - END **/

}

EBallotionController.$inject = ['$rootScope', '$scope', '$localStorage', '$window', '$timeout', 'Fullscreen','SSUserService',
    'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfirmationService', 'SSAppService', 'SSAwsService',
    'OTPService', 'SSConfigService', 'SSStackviewService'];
app.controller('EBallotionController', EBallotionController);
